import "../../fonts.css";
import "../../GlobalWidgetStyles.css";

export const GlobalCss = () => {
    return <></>;
};
